import LegalLayout from "@/pages/legal/LegalLayout";

const SECTIONS = [
  {
    id: "introduction",
    label: "Introduction",
    body: [
      "This website may use cookies and similar technologies to support functionality, performance, and ongoing improvement of the website experience. This Cookie Policy explains, in plain language, what cookies are and how they may be used here.",
    ],
  },
  {
    id: "what-cookies-are",
    label: "What Cookies Are",
    body: [
      "Cookies are small text files placed on your device when you visit a website. They allow the site to recognize your device, remember preferences, and gather basic information about how the site is used. Similar technologies include local storage, pixels, and tags.",
    ],
  },
  {
    id: "types",
    label: "Types of Cookies We May Use",
    body: [
      {
        type: "list",
        items: [
          "Essential cookies — needed for the website to function properly",
          "Performance or analytics cookies — help understand how visitors interact with the site",
          "Functionality cookies — enable additional features and remember choices",
          "Preference cookies — store options to provide a more consistent experience",
        ],
      },
    ],
  },
  {
    id: "why",
    label: "Why We Use Cookies",
    body: [
      "Cookies may be used to:",
      {
        type: "list",
        items: [
          "support core website functionality",
          "remember user preferences",
          "understand traffic patterns and overall usage",
          "improve experience over time",
          "support performance, maintenance, and security",
        ],
      },
    ],
  },
  {
    id: "managing",
    label: "Managing Cookies",
    body: [
      "You can manage cookies through your browser settings. Most browsers allow you to view, delete, or block cookies, and to receive notifications when new cookies are placed.",
      "Where a cookie preferences interface is provided on the website, you may also adjust your choices there. Disabling certain cookies may affect parts of the website experience.",
    ],
  },
  {
    id: "third-party",
    label: "Third-Party Cookies",
    body: [
      "Certain embedded tools or external services used on the website may place cookies where applicable. The handling of those cookies is subject to the relevant third-party policies, which we encourage visitors to review where they wish.",
    ],
  },
  {
    id: "changes",
    label: "Changes to This Policy",
    body: [
      "This Cookie Policy may be updated from time to time. Revised versions will be posted on the website with an updated effective date.",
    ],
  },
  {
    id: "contact",
    label: "Contact",
    body: [
      "For questions regarding cookies, please write to:",
      { type: "mono", lines: ["info@erenown.com"] },
    ],
  },
];

export default function CookiePolicy() {
  return (
    <LegalLayout
      eyebrow="Cookie Policy"
      title="Cookie Policy."
      originallyPublished="01 September 2020"
      lastUpdated="16 October 2021"
      intro="A short, clear summary of how cookies and similar technologies may be used to support the Erenown website experience."
      sections={SECTIONS}
    />
  );
}
